import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OrderDetail from './components/OrderDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageIOrder',
  components: {
    OrderDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;